import { configurationContainer } from "@/configurationContainer";

export const getBaseWsUrl = (): string =>
    configurationContainer.PUBLIC_ODIN_WS_URL;
